import {
  APP_INITIALIZER,
  ApplicationConfig,
  ErrorHandler,
} from '@angular/core';
import { provideRouter, Router } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';

import { routes } from './app.routes';
import { environment } from '../environments/environment';
import { GameApi } from './shared/api/game-api';
import { API_BASE_URL, HttpGameApi } from './shared/api/http-game-api';
import { authInterceptor } from './shared/interceptors/auth.interceptor';
import { retryInterceptor } from './shared/interceptors/retry.interceptor';
import { bridgeInterceptor } from './shared/interceptors/bridge.interceptor';
import { SessionService } from './shared/services/session.service';
import { apiErrorInterceptor } from './shared/interceptors/api-error.interceptor';
import { GlobalErrorHandler } from './shared/errors/global-error-handler';
import * as Sentry from '@sentry/angular';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideHttpClient(
      withInterceptors([
        apiErrorInterceptor,
        authInterceptor,
        retryInterceptor,
        bridgeInterceptor,
      ]),
    ),
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    { provide: API_BASE_URL, useValue: environment.backendUrl },
    { provide: GameApi, useClass: HttpGameApi },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      multi: true,
      deps: [Sentry.TraceService],
      useFactory: () => () => {},
    },
    {
      provide: APP_INITIALIZER,
      multi: true,
      deps: [SessionService],
      useFactory: (session: SessionService) => () => {
        session.init();
      },
    },
  ],
};
